export default "__VITE_ASSET__0b8e56eb__"